import T from 'prop-types'
import React from 'react'
import cx from 'classnames'

class CircleLoader extends React.PureComponent {
  static displayName = 'CircleLoader'

  static propTypes = {
    loading: T.bool,
    saving: T.bool,
    overlay: T.bool,
    className: T.string,
    dark: T.bool,
    transparent: T.bool
  }

  static defaultProps = {
    className: '',
    saving: false
  }

  render() {
    const props = this.props
    const className = cx('loading_circle', props.className, {
      loadcir_loading: props.loading || props.saving,
      loadcir_overlay: props.overlay,
      loadcir_dark: props.dark,
      loadcir_transparent: props.transparent,
      loadcir_saving: props.saving
    })
    return (
      <div className={className}>
        <div className="cir inner" />
        <div className="cir outer" />
      </div>
    )
  }
}

export default CircleLoader
